import { Module } from "vuex";
import type { RouteRecordRaw } from "vue-router";
import { accountLoginRequest, userInfoRequest, getAllEnums } from "@/service/login";
import { AccountLoginType } from "@/service/login/types";
import localCache from "@/utils/cache";
import { RootStateType } from "../types";
import { LoginStateType, UserInfoType, RoleInfoType } from "./types";
import { ElMessage } from 'element-plus'
import router from '@/router';
import Layout from '@/views/main/Main.vue'
import local from '@/utils/cache'
import md5 from 'js-md5';
const loginModule: Module<LoginStateType, RootStateType> = {
  namespaced: true,
  state(): LoginStateType {
    return {
      token: "",
      name: "",
      userInfo: {},
      roleList: [],
      userMenus: [],
      permissionList: [],
      userType: '',
      activeRouter: '/',
      enums: {}
    };
  },
  getters: {},
  mutations: {
    changeActiveRouter(state: LoginStateType, payload: string) {
      state.activeRouter = payload;
    },
    //设置token
    changeToken(state: LoginStateType, token: string) {
      state.token = token;
    },
    changeUser(state: LoginStateType, value: string) {
      state.userType = value;
    },
    //设置用户信息
    changeUserInfo(state, payload: UserInfoType): void {
      state.userInfo = payload;
    },
    //设置菜单权限
    changeUserMenus(state: LoginStateType, payload: any[]): void {
      state.userMenus = payload;
      //添加路由
      // payload.forEach(item => {
      //   router.addRoute(item);
      // })
    },
    //设置用户按钮权限
    changePermissionList(state: LoginStateType, payload: string[]): void {
      state.permissionList = payload
    },
    //设置用户角色列表
    changeRoleList(state: LoginStateType, payload: RoleInfoType[]): void {
      state.roleList = payload
    },
    //用户名称
    changeName(state: LoginStateType, payload: string): void {
      state.name = payload;
    },
    //获取全局使用枚举
    changeEnums(state: LoginStateType, payload: any = {}): void {
      state.enums = payload;

    }

  },
  actions: {
    //登录
    async accountLoginAction(context, payload: AccountLoginType) {
      const { account, password ,captchaCode } = payload;
      // accountLoginRequest({ account, password: md5(password) }).then(res => {
      accountLoginRequest({ account, password ,captchaCode}).then(res => {
        if (res.code == 200) {
          const arr = res.data.split(";")
          context.commit('changeToken', arr[0]);
          context.commit('changeUser',arr[1]);
          localCache.setCache("token", arr[0]);
          localCache.setCache("identity", arr[1]);
            if(arr[1] == 'SuperAdmin' || arr[1] == 'Admin') {
              router.push('/dashboard')
            }else {
              router.push('/gyxHomePage');
            }
        } else {
          ElMessage.error(res.message);
        }
      }).catch(err => JSON.stringify(err))

    },
    //获取用户信息
    userInfoAction(context) {
      userInfoRequest().then((res) => {
        if (res.code == 200) {
          const { data } = res;
          localCache.setCache("changePasswordId", data.id);
          
          //用户信息
          context.commit('changeUserInfo', data);
          //用户名
          context.commit('changeName', data.name);
          //用户菜单权限列表
          context.commit('changeUserMenus', data.menus);
          //用户按钮权限
          context.commit('changePermissionList', data.permissions);
          //角色列表
          context.commit('changeRoleList', data.roles);
        } else {
          ElMessage.error(`获取用户信息失败${res?.code}--${JSON.stringify(res.message)}`)
        }
      }).catch(err => {
        return '';
        // ElMessage.error(err)
      })
    },
    //获取全局枚举
    getEnums(context) {
      // console.log(enmuData)
      // const obj = {
      //   CodeList: enmuData
      // }
      // getAllEnums(obj).then(res => {
      //   console.log(res)
      //   if (res.code == 200) {
      //     context.commit('changeEnums', res.data);
      //   } else {
      //     ElMessage.error(`获取全局枚举失败${res.code}:${JSON.stringify(res.message)}`);
      //   }
      // }).catch(err => {
      //   console.log(JSON.stringify(err))
      // })
    },
    uploadAction(context) {
      const token = localCache.getCache("token");
      if (token) {
        context.commit("changeToken", token);
      }
      const userInfo = localCache.getCache("userInfo");
      if (userInfo) {
        context.commit("changeUserInfo", userInfo);
      }
      const userMenus = localCache.getCache("userMenus");
      if (userMenus) {
        context.commit("changeUserMenus", userMenus);
      }
    }
  }
};

export default loginModule

